import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames/bind';
import Icon from '../../src/components/Icon/Icon';

const Tip = ({ className, children, ...rest }) =>
  <div className={cx('example-tip', className)} {...rest}>
    <Icon name="info" className="info-icon"/>
    <div className="info">
      {children}
    </div>
  </div>;

Tip.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Tip;
